<template>
  <section>
    <v-layout row justify-center align-center class="my-3">
      <v-flex xs12 md8>
        <v-icon class="my-1" color="primary">money</v-icon>&nbsp;&nbsp;<span class="txt-titulo">Deudas (pasivos)</span>
      </v-flex>
    </v-layout>
    <v-stepper v-model="e6" vertical class="elevation-6">
      <v-stepper-step :complete="e6 > '1'" step="1" :editable='true'>Deudas con Entidades Financieras</v-stepper-step>
      <v-stepper-content step="1">
        <!-- <v-card color="grey lighten-1" class="mb-5" height="800px"></v-card> -->
        <financiera v-if="e6 === '1'"></financiera>
        <v-flex xs3 offset-xs9 align-end>
          <v-btn color="accent" @click="e6 = '2'"><v-icon>arrow_downward</v-icon>&nbsp;Siguiente</v-btn>
        </v-flex>
      </v-stepper-content>
      <v-stepper-step :complete="e6 > '2'" step="2" :editable='true'>Deudas con Personas Naturales y Jurídicas de Derecho Privado</v-stepper-step>
      <v-stepper-content step="2" >
        <naturalesJuridica v-if="e6 === '2'"></naturalesJuridica>
        <v-flex xs3 offset-xs9 align-end>
          <v-btn color="secondary" @click.native="e6 = '1'"><v-icon>arrow_upward</v-icon>&nbsp;Anterior</v-btn>
          <v-btn color="accent" @click="e6 = '3'"><v-icon>arrow_downward</v-icon>&nbsp;Siguiente</v-btn>
        </v-flex>
      </v-stepper-content>

      <v-stepper-step :complete="e6 > '3'" step="3" :editable='true'>Deudas con Entidades Estatales</v-stepper-step>
      <v-stepper-content step="3">
        <estatales v-if="e6 === '3'"></estatales>
        <v-flex xs3 offset-xs9 align-end>
          <v-btn color="secondary" @click.native="e6 = '2'"><v-icon>arrow_upward</v-icon>&nbsp;Anterior</v-btn>
          <v-btn color="accent" @click="e6 = '4'"><v-icon>arrow_downward</v-icon>&nbsp;Siguiente</v-btn>
        </v-flex>
      </v-stepper-content>

      <v-stepper-step :complete="e6 > '4'" step="4" :editable='true'>Deudas al Fisco</v-stepper-step>
      <v-stepper-content step="4">
        <fisco v-if="e6 === '4'"></fisco>
        <v-flex xs3 offset-xs9 align-end>
          <v-btn color="secondary" @click.native="e6 = '3'"><v-icon>arrow_upward</v-icon>&nbsp;Anterior</v-btn>
          <v-btn color="accent" @click="e6 = '5'"><v-icon>arrow_downward</v-icon>&nbsp;Siguiente</v-btn>
        </v-flex>
      </v-stepper-content>

      <v-stepper-step :complete="e6 > '5'" step="5" :editable='true'>Otras Deudas</v-stepper-step>
      <v-stepper-content step="5">
        <otras v-if="e6 === '5'"></otras>
        <v-flex xs3 offset-xs9 align-end>
          <v-btn color="secondary" @click.native="e6 = '4'"><v-icon>arrow_upward</v-icon>&nbsp;Anterior</v-btn>
        </v-flex>
      </v-stepper-content>
    </v-stepper>
    <v-layout align-center wrap>
      <v-flex md8 />
      <v-flex xs3 offset-xs9 align-end>
        <v-btn color="secondary" @click="$router.push('/bienes')"><v-icon right dark>arrow_back_ios</v-icon>&nbsp;Anterior</v-btn>
        <v-btn color="accent" @click="$router.push('/parentesco')">Siguiente&nbsp;<v-icon right dark>arrow_forward_ios</v-icon></v-btn>
      </v-flex>
    </v-layout>
  </section>
</template>
<script>
import Financiera from '@/components/deudas/financiera';
import NaturalesJuridica from '@/components/deudas/naturalesJuridicas';
import Estatales from '@/components/deudas/estatales';
import Fisco from '@/components/deudas/fisco';
import Otras from '@/components/deudas/otras';
import Parametricas from '../djbrd/mixins/parametricas';
export default {
  mixins: [ Parametricas ],
  created () {
    // this.navBarEmmit();
    this.obtenerEstadoDeclaracion().then(respuesta => {
      if (respuesta.finalizado) {
        if (respuesta.data.cod_estado === 3) {
          this.$message['warning']('Debe iniciar una nueva Declaración.');
          this.$router.push('/');
        }
        if (respuesta.data.cod_estado === 2) {
          this.$message['warning']('Su ultima Declaración no fue recepcionada, habilite la misma para terminarla');
          this.$router.push('/');
        }
        if (respuesta.data.cod_estado === -1) {
          this.$message['warning']('Debe iniciar una nueva Declaración.');
          this.$router.push('/');
        }
      }
    });
    this.$service.get('djbr_registro/valida_declaracion', {}).then(response => {
      if (response[0] && response[0].err_existente !== 0) {
        this.$message['warning'](response[0].err_mensaje + ' ' + 'volver a Datos Generales');
        this.$router.push('datos-generales');
      }
    });
  },
  components: {
    Financiera,
    NaturalesJuridica,
    Estatales,
    Fisco,
    Otras
  },
  data: () => ({
    user: {},
    stepper: 0,
    e6: '1',
    steps: [
      {
        label: 'Deudas con Entidades Financieras',
        completed: false
      },
      {
        label: 'Deudas con Personas Naturales y Jurídicas de Derecho Privado',
        completed: false
      },
      {
        label: 'Deudas con Entidades Estatales',
        completed: false
      },
      {
        label: 'Deudas al Fisco',
        completed: false
      },
      {
        label: 'Otras Deudas',
        completed: false
      }
    ]
  }
)
};
</script>



// WEBPACK FOOTER //
// src/components/declaracion/deudas.vue